import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuEditarComponent } from './menu-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: MenuEditarComponent }
    ])],
    exports: [RouterModule]
})
export class MenuEditarRoutingModule { }
